// Lexo URL bazë nga .env
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL?.trim() || "";

// Nuk kemi më appsettings.json, prandaj s'na duhet loadConfig ose getConfig
export async function loadConfig() {
  return { apiUrl: API_BASE_URL };
}

export function getConfig() {
  return { apiUrl: API_BASE_URL };
}

// Merr URL bazë pa /api në fund (nëse ekziston)
export function getBaseUrl() {
  return API_BASE_URL.replace(/\/api\/?$/, "");
}

// Ndërton URL për hub (p.sh. SignalR ose endpoint të tjera)
export function getHubUrl(path) {
  const base = getBaseUrl();
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}
